import React, { useState } from 'react'

import { Text } from '@interco/inter-ui/components/Text'
import { Accordion } from '@interco/inter-ui/components/Accordion'
import Warning from '@/components/Warning'

import * as S from './style'

type Content = {
  topic: string
  questions: { title: string; description: string }[]
}

const InvestingContent: Content[] = [
  {
    topic: 'Fundo de investimento',
    questions: [
      {
        title: `Identificação do Produto`,
        description: `Informações de identificação do produto, Código ISIN, Classificação ANBIMA, Classe e subclasse.`,
      },
      {
        title: `Posição do cliente`,
        description: `Saldo bloqueado, líquido e bruto, quantidade de cotas, valor bruto de cota, impostos provisionados.`,
      },
      {
        title: `Movimentações`,
        description: `Identificação da movimentação, data de conversão, quantidade de cotas movimentada, valor da cota, valor da movimentação, valor líquido e bruto da movimentação e impostos.`,
      },
    ],
  },
  {
    topic: 'Renda fixa bancária',
    questions: [
      {
        title: `Identificação do Produto`,
        description:
          'Informações de identificação do produto, informações de remuneração do produto, data de vencimento, aquisição, data fim carência.',
      },
      {
        title: `Posição do cliente`,
        description:
          'Saldo bloqueado, líquido e bruto, quantidade título, preço unitário, impostos provisionados.',
      },
      {
        title: `Movimentações`,
        description:
          'Identificação da movimentação, Preços unitário e quantidade movimentados, valores liquido e bruto da movimentação, impostos e indexadores.',
      },
    ],
  },
  {
    topic: 'Renda Fixa Crédito Privado',
    questions: [
      {
        title: `Identificação do Produto`,
        description:
          'Informações de identificação do produto, informações de remuneração do produto, data de vencimento, aquisição, data fim carência, pagamento de cupom.',
      },
      {
        title: `Posição do cliente`,
        description:
          'Saldo bloqueado, liquido e bruto, quantidade título, preço unitário, impostos provisionados, multa e mora.',
      },
      {
        title: `Movimentações`,
        description:
          'Identificação da movimentação, Preços unitário e quantidade movimentados, valores liquido e bruto da movimentação, impostos e indexadores.',
      },
    ],
  },
  {
    topic: 'Renda Variável',
    questions: [
      {
        title: `Identificação do Produto`,
        description: 'Informações de identificação do produto (código ISIN e ticker).',
      },
      {
        title: `Posição do cliente`,
        description:
          'Saldo bloqueado, liquido e bruto, quantidade, preço unitário, impostos provisionados, multa e mora.',
      },
      {
        title: `Movimentações`,
        description:
          'Identificação da movimentação, Preços unitário e quantidade movimentada, valor da movimentação, data da movimentação.',
      },
      {
        title: `Detalhes da nota de negociação`,
        description:
          'Número da nota, valor monetário das taxas aplicáveis, emolumentos, impostos e valor líquido da nota.',
      },
    ],
  },
  {
    topic: 'Tesouro Direto',
    questions: [
      {
        title: `Identificação do Produto`,
        description:
          'Informações de identificação do produto, informações de remuneração do produto, data de vencimento, aquisição, data fim carência, pagamento de cupom.',
      },
      {
        title: `Posição do cliente`,
        description:
          'Saldo bloqueado, liquido e bruto, quantidade título, preço unitário, impostos provisionados, multa e mora.',
      },
      {
        title: `Movimentações`,
        description:
          'Identificação da movimentação, Preços unitário e quantidade movimentados, valores liquido e bruto da movimentação, impostos e indexadores.',
      },
    ],
  },
  {
    topic: 'Câmbio',
    questions: [
      {
        title: `Identificação do Produto`,
        description:
          'Informações de identificação do produto, informações de remuneração do produto, data de vencimento, aquisição, data fim carência, pagamento de cupom.',
      },
      {
        title: `Posição do cliente`,
        description:
          'Saldo bloqueado, liquido e bruto, quantidade título, preço unitário, impostos provisionados, multa e mora.',
      },
      {
        title: `Movimentações`,
        description:
          'Identificação da movimentação, Preços unitário e quantidade movimentados, valores liquido e bruto da movimentação, impostos e indexadores.',
      },
    ],
  },
]

export const Investing = () => {
  const [expandedItems, setExpandedItems] = useState<{ [key: number]: boolean }>({})

  const handleToggle = (index: number) => {
    setExpandedItems((prev) => ({
      ...prev,
      [index]: !prev[index],
    }))
  }

  return (
    <S.Container>
      <S.Content>
        <Text variant="body-2" style={{ paddingBottom: 16, fontSize: 16 }}>
          Estes serão os dados compartilhados:
        </Text>
        <Warning text="A autorização incluirá os dados das novas contratações e operações." />
      </S.Content>
      <S.Content>
        <Text variant="body-1" bold colorWeight={500} style={{ fontSize: 18 }}>
          Operações de investimentos
        </Text>
        <Text variant="body-2" style={{ fontSize: 14 }}>
          As operações referem-se a contratos de renda fixa, renda variável, tesouro direto e fundos
          de investimentos. São informações como: identificação do produto, informações de
          remuneração, data de emissão, vencimento, aquisição, data fim de carência, saldo
          bloqueado, líquido e bruto, quantidade de título, preço unitário, impostos provisionados,
          multa e mora, indexadores, código ISIN, Classificação ANBIMA, Classe e Subclasse.
        </Text>
      </S.Content>
      <S.Accordion>
        {InvestingContent.map((content, index) => (
          <Accordion
            style={{ paddingLeft: 0, paddingTop: 0, width: '100%' }}
            key={content.topic}
            title={content.topic}
            expanded={expandedItems[index]}
            onClick={() => handleToggle(index)}
          >
            <S.AccordionInfo>
              {content.questions.map((question) => (
                <React.Fragment key={question.title}>
                  <Text variant="headline-h3" semiBold style={{ fontSize: 14 }}>
                    {question.title}
                  </Text>
                  <Text variant="body-2" style={{ fontSize: 14, paddingBottom: 20 }}>
                    {question.description}
                  </Text>
                </React.Fragment>
              ))}
            </S.AccordionInfo>
          </Accordion>
        ))}
      </S.Accordion>
    </S.Container>
  )
}
